import { Box, BoxProps, Checkbox } from '@ff-it/ui';

import { ReactElement } from 'react';
import { useForm } from 'react-final-form';

type BandDayTypeSplitToggleProps = BoxProps & {
  split: boolean;
  initialBandValue: any;
  disabled?: boolean;
  /** Shortened where the control sits in a narrow column head. */
  label?: string;
};

// Attomic togle for split and bands
export function BandDayTypeSplitToggle({
  split,
  initialBandValue,
  disabled,
  label = 'Weekday / weekend split',
  ...props
}: BandDayTypeSplitToggleProps): ReactElement {
  const form = useForm();

  return (
    <Box display="flex" alignItems="center" mt="1" fontSize="md" {...props}>
      <Checkbox
        checked={split}
        disabled={disabled}
        size="sm"
        onChange={() => {
          if (disabled) {
            return;
          }
          const i = Date.now();
          form.change(
            'bands',
            !split
              ? {
                  day_type_split: true,
                  WE: [{ ...initialBandValue, __NEW__: i }],
                  WD: [{ ...initialBandValue, __NEW__: i + 1 }],
                }
              : { day_type_split: false, ALL: [{ ...initialBandValue, __NEW__: i + 2 }] },
          );
        }}
        id="split-toggle"
      />
      <Box as="label" mb="0" ml="2" htmlFor="split-toggle" fontWeight="regular" whiteSpace="nowrap">
        {label}
      </Box>
    </Box>
  );
}
